import { compact } from 'lodash';
import { MARKET } from '@nandosaus/constants';

import { navigation } from '../constants';

const isAustralia = (market, AuNavItem, navItem) => (market === MARKET.AUSTRALIA ? AuNavItem : navItem);

const getPrimaryNavigationItems = (market, cateringEnabled = true) =>
  compact([
    {
      label: 'Menu',
      href: navigation.MENU,
    },
    cateringEnabled && {
      label: 'Catering',
      href: navigation.CATERING,
    },
    {
      label: 'Restaurants',
      href: navigation.RESTAURANTS,
    },
    {
      label: 'PERi Products',
      href: navigation.PRODUCTS,
      cmsLink: true,
    },
    isAustralia(
      market,
      {
        label: 'Careers',
        href: navigation.CAREERS,
        cmsLink: true,
      },
      {
        label: 'Our Story',
        href: navigation.OUR_STORY,
        cmsLink: true,
      }
    ),
    {
      label: 'PERi-Perks',
      href: navigation.PERI_PERKS,
      preserveLabel: 'PERi-PERKS',
    },
  ]);

const getSecondaryNavigationItems = ({ market, allergenNavigationItem, cateringEnabled = true }) =>
  compact([
    {
      label: 'Download App',
      href: navigation.APP,
    },
    isAustralia(market, {
      label: 'Nutritional Information',
      href: navigation.NUTRITIONAL_INFORMATION,
    }),
    cateringEnabled && {
      label: 'Catering',
      href: navigation.CATERING,
    },
    {
      label: 'Recipes',
      href: navigation.RECIPES,
    },
    { label: 'News', href: navigation.NEWS },
    {
      label: 'Gift Cards',
      href: navigation.GIFT_CARDS,
    },
    allergenNavigationItem,
    {
      label: 'Careers',
      href: navigation.CAREERS,
      cmsLink: true,
    },
    {
      label: 'Help',
      href: navigation.HELP,
      target: null,
    },
  ]);

const getSocialNavigationItems = market => {
  if (market === MARKET.AUSTRALIA) {
    return [
      {
        label: 'Nando’s on Facebook',
        href: 'https://www.facebook.com/nandosaus',
        icon: 'facebook',
      },
      {
        label: 'Nando’s on Instagram',
        href: 'https://www.instagram.com/nandosaus',
        icon: 'instagram',
      },
      {
        label: 'Nando’s on Twitter',
        href: 'https://twitter.com/nandosaus',
        icon: 'twitter',
      },
    ];
  }

  if (market === MARKET.NEW_ZEALAND) {
    return [
      {
        label: 'Nando’s on Facebook',
        href: 'https://www.facebook.com/NZNandos',
        icon: 'facebook',
      },
      {
        label: 'Nando’s on Instagram',
        href: 'https://www.instagram.com/nznandos',
        icon: 'instagram',
      },
    ];
  }

  throw new Error(`Unsupported market specified: ${market}`);
};

const getNavigationItems = (navType, { market, allergenNavigationItem, cateringEnabled = true }) => {
  switch (navType) {
    case 'primary':
      return getPrimaryNavigationItems(market, cateringEnabled);
    case 'secondary':
      return getSecondaryNavigationItems({ market, allergenNavigationItem, cateringEnabled });
    case 'social':
      return getSocialNavigationItems(market);
    case 'footer':
      return [
        {
          label: 'Terms & Conditions',
          href: navigation.TERMS_CONDITIONS,
        },
        {
          label: 'Privacy Policy',
          href: navigation.PRIVACY_POLICY,
        },
      ];
    default:
      throw new Error(`Unsupported navType specified: ${navType}`);
  }
};

export { getNavigationItems };
